import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpClient,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})

export class DevicesocketService extends Socket {

  private endpoint = environment.endpoint;
  private url = this.endpoint;

  constructor(
    private httpclient: HttpClient
  ) {
    super({ url: environment.socketUrl, options: {} });
  }

}
